import { Spinner } from 'components/Spinner'

import { Overlay } from './Overlay'

export const LoadingScreen = () => (
	<Overlay>
		<Spinner />
	</Overlay>
)
